var r = {};
export {
  r as __exports
};
//# sourceMappingURL=index.es282.js.map
